import { render } from "./completeReferenceArm.vue?vue&type=template&id=324c9f30&scoped=true"
import script from "./completeReferenceArm.vue?vue&type=script&lang=js"
export * from "./completeReferenceArm.vue?vue&type=script&lang=js"

import "./completeReferenceArm.vue?vue&type=style&index=0&id=324c9f30&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324c9f30"]])

export default __exports__